import React from "react";
import { Link } from "react-router";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import ActionButton from "../components/ActionButton";
import SecurityNotice from "../components/SecurityNotice";
import SEO from "../components/SEO";
import tools, { TOOL_ICON_COLOR_CLASSES } from "../data/tools";

function Home() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 2026-07-04 tools-wide overhaul (operator-approved) : every page
          must carry a canonicalUrl so search engines collapse duplicate
          URLs (e.g. with tracking params) onto the one true address ;
          the home page canonical is the bare site root. */}
      <SEO
        title="Free SSL Certificate Tools - CSR Generator, Chain Analyzer & More"
        description="Professional SSL Certificate tools including CSR generator, SSL Certificate chain analyzer, SSL Certificate matcher, CSR decoder, and PFX converter. Free online SSL tools for developers and system administrators."
        keywords="SSL tools, SSL Certificate tools, CSR generator, SSL Certificate chain analyzer, SSL Certificate matcher, CSR decoder, PFX converter, free SSL tools, online SSL tools"
        canonicalUrl="https://tools.trustico.com/"
      />
      {/* Hero Section.
          2026-07-04 operator consistency directive : the page title is
          h1 text-3xl font-bold on every page (the CSRGenerator.jsx
          reference size) ; the home hero previously used text-4xl. */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-heading mb-4 text-center">
          Professional SSL Certificate Tools
        </h1>
        <p className="text-body">
          Free tools for working with SSL Certificates, from the first
          Certificate Signing Request (CSR) to an installed and verified SSL
          Certificate. Generate and decode CSRs, analyze installed chains, match
          an SSL Certificate to its private key, convert formats and manage CAA
          records, free of charge and with no account needed. To issue an SSL
          Certificate, use the credentials from your Trustico® Certificate as a
          Service (CaaS) license.
        </p>
      </div>

      <SecurityNotice />

      {/* Tools Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {tools.map((tool) => (
          <Link
            key={tool.href}
            to={tool.href}
            className="card card-hover p-6 group"
          >
            <div className="flex flex-col items-center text-center h-full">
              <tool.icon
                className={`tool-icon ${TOOL_ICON_COLOR_CLASSES[tool.color] || "text-link"} group-hover:scale-110 transition-transform`}
              />
              {/* 2026-07-04 operator consistency directive : section
                  and card headings use the reference size (text-lg
                  font-semibold) ; these cards previously used text-xl. */}
              <h2 className="text-lg font-semibold text-heading mb-2">
                {tool.title}
              </h2>
              <p className="text-body mb-4 grow">{tool.description}</p>
              <div className="mt-auto">
                <ActionButton variant="primary" icon={ChevronRightIcon}>
                  {tool.buttonText || "Launch Tool"}
                </ActionButton>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Home;
